import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

export const SearchCategory = ({ setCategories }) => {

  const [inputValue, setInputValue] = useState('')

  const handleInputChange = ( e ) => {
    setInputValue (e.target.value);
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (inputValue.trim().length > 2 ) {
      
      setCategories([ inputValue ]);
      setInputValue('');
    }
  }

  return (
      <form onSubmit={ handleSubmit } className='express'>
        <Form.Group className='form_group_form'>
          <Form.Control 
            type="text"
            value={ inputValue }
            onChange={ handleInputChange }
            placeholder="Ingresa el nombre del curso"
           />
        </Form.Group>

        <Button           
          type="submit"
          variant="primary"
          onClick={ handleSubmit }>
            Buscar
        </Button>

      </form>
  )
}

SearchCategory.propTypes = {
  setCategories: PropTypes.func.isRequired
}